import Feature from 'ol/Feature';
import PropTypes from 'prop-types';
import styles from './Observation.module.scss';
import { FormattedMessage, useIntl } from 'react-intl';
import FeaturePanelOpenButton from 'client/components/FeaturePanelOpenButton/FeaturePanelOpenButton';
import AssetInfo from 'client/pages/MapPage/components/MapMenu/AssetInfo/AssetInfo';

const Observation = ({ feature, ...props }) => {
    const values = feature.getProperties();
    const intl = useIntl();

    return (
        <div className={styles.container} data-testid={props['data-testid']}>
            <h3 className="govuk-heading-m">
                {values.objectname || <FormattedMessage id={'observationsTab.untitledObservation'} />}
            </h3>
            <FeaturePanelOpenButton feature={feature} />
            {values.observationcategory && <AssetInfo title={intl.formatMessage({ id: 'observationsTab.category' })}>{values.observationcategory}</AssetInfo>}
            {values.notes && <AssetInfo title={intl.formatMessage({ id: 'observationsTab.notes' })}>{values.notes}</AssetInfo>}
        </div>
    );
};

Observation.propTypes = {
    feature: PropTypes.instanceOf(Feature).isRequired,
    'data-testid': PropTypes.string
};

Observation.defaultProps = {
    'data-testid': 'Observation'
};

export default Observation;
